<template>
  <AttrSwitch
    class="mt-2.5"
    label="自定义位置"
    :value="!!shape.attrs.movable"
    :disabled="!!attrDisabled"
    @change="onMovableChange"
  />
  <div v-if="shape.attrs.movable">
    <div
      v-for="(item, index) in shape.attrs.positions"
      :key="`position${index}`"
      class="flex justify-between items-center mt-2.5 ml-1 mr-2"
    >
      <div class="w-11">
        {{ `位置${index + 1}` }}
        <div class="ml-3 cursor-pointer" @click.stop="onPreviewChange(index)">
          <Icon
            class="svg-transition-none"
            :icon="`${
              index === (shape.attrs.curSlotPosition ?? 0)
                ? 'eye-open'
                : 'eye-close'
            }.svg`"
            :width="15"
            :height="15"
            fill="none"
          />
        </div>
      </div>
      <div class="w-30">
        <AttrInputNumber
          label="X"
          :value="item.x"
          :width="60"
          :precision="0"
          addon-after="px"
          @change="(v: number) => onInputChange(index, v, 'x')"
        />
      </div>
      <div class="w-30">
        <AttrInputNumber
          label="Y"
          :value="item.y"
          :precision="0"
          :width="60"
          addon-after="px"
          @change="(v: number) => onInputChange(index, v, 'y')"
        />
      </div>
      <div class="flex w-9 justify-between">
        <div
          class="opacity-70 hover:opacity-100"
          @click.stop="addPosition(index)"
        >
          <icon icon="add.svg" fill="none" :width="15" />
        </div>
        <div
          class="opacity-70 hover:opacity-100"
          @click.stop="deletePosition(index)"
        >
          <icon icon="delete2.svg" fill="white" :width="16" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { PropType, computed } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});
const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled || props.disabled);

const onInputChange = (index: number, value: number, key: 'x' | 'y') => {
  const positions = props.shape.attrs.positions;
  if (positions) {
    positions[index][key] = value;
    props.shape.setAttrs({
      positions: positions
    });
  }
};

const addPosition = (index: number) => {
  const positions = props.shape.attrs.positions;
  if (positions) {
    positions.push({
      x: positions[index].x,
      y: positions[index].y
    });
    props.shape.setAttrs({
      positions: positions
    });
  }
};

const deletePosition = (index: number) => {
  const positions = props.shape.attrs.positions;
  if (!positions || positions.length <= 1) return;
  else {
    positions.splice(index, 1);
    props.shape.setAttrs({
      positions: positions
    });
    if (index === props.shape.attrs.curSlotPosition) {
      props.shape.setAttrs({
        curSlotPosition: 0,
        x: positions[0].x,
        y: positions[0].y
      });
    }
  }
};

const onMovableChange = (value: boolean) => {
  props.shape.setAttrs({ movable: value });
  if (value) {
    const positions = [
      { x: props.shape.attrs.x ?? 0, y: props.shape.attrs.y ?? 0 }
    ];
    props.shape.setAttrs({
      positions: positions
    });
  } else {
    props.shape.setAttrs({ positions: [] });
  }
};

const onPreviewChange = (index: number) => {
  const positions = props.shape.attrs.positions;
  if (positions)
    props.shape.setAttrs({
      curSlotPosition: index
      // x: positions[index].x,
      // y: positions[index].y
    });
};
</script>
